import { jwtDecode } from 'jwt-decode'
import { defineStore } from 'pinia'
import { connectedGames } from '@/components/goat/page/home/ConnectGameDialog'
import { siteUtils } from '@/compositions/siteUtils'
import { useGoatStore } from '@/stores/goat'
import { ModeEnum } from '@/types/enums'

export interface AuthState {
  token?: string
  email?: string
  games?: Record<Games.GameKeyType, string>
  id?: string
  valid?: string
  com?: boolean
}
const useAuthStore = defineStore('storeAuth', () => {
  const auth = ref<AuthState>({})

  const getAuthFullData = computed(() => auth.value)
  const getToken = computed(() => auth.value?.token || '')
  const getEmail = computed(() => auth.value?.email || '')
  const getCom = computed(() => auth.value?.com || false)
  const isLogged = computed(() => {
    return !!auth.value?.token
  })

  function login(authToken: string, email: string) {
    try {
      const decoded: AuthState = jwtDecode(String(authToken))
      auth.value = {
        token: authToken,
        email,
        games: decoded?.games ?? {},
        id: decoded?.id ?? '',
        valid: decoded?.valid ?? '',
        com: decoded?.com || false
      }
    } catch (err) {
      console?.error?.('not decoded jwt', err) // no token / e-mail in the log - console output ends up in Sentry breadcrumbs
    }
    siteUtils.updateMode(ModeEnum.loggedin)
  }
  function logout() {
    const { getAxiosInstance } = appUtilsPlugin
    const { getGoatApiUrl } = siteUtils
    getAxiosInstance()?.get(getGoatApiUrl('logout')).catch((err: Error) => {
      // eslint-disable-next-line no-console
      console?.log(err)
    })
    auth.value = {}
    siteUtils.updateMode(ModeEnum.login)
    connectedGames.value = {}
    const goat = useGoatStore()
    goat.clearGoatData()
  }
  function updateCom(com = false) {
    auth.value.com = com
  }

  return {
    auth,
    getToken,
    getEmail,
    getCom,
    login,
    logout,
    isLogged,
    updateCom,
    getAuthFullData
  }
}, { persist: !import.meta.env.SSR })

export { useAuthStore }
